<script setup lang="ts">
import { computed } from 'vue'

import VodEpgBadges from './../shared/vod-epg/Badges.vue'
import MetadataHeader from './../content-header/MetadataHeader.vue'
import Headline from './../content-header/Headline.vue'
import Roofline from './../content-header/Roofline.vue'
import Channel from './../../apps/tvmovie/theme/EpgSearch/Channel.vue'

import type { ComposedBody } from '@xcel-next/composer-schema'

export type AdditionalHeaders = NonNullable<ComposedBody['additionalHeaders']>

const props = defineProps<{
  additionalHeaders?: AdditionalHeaders
  roofline?: string
  headline?: string
  seeding?: { enabled?: boolean, headlineId?: string }
}>()

const startTime = computed(() => props.additionalHeaders?.metadata?.top?.airTime?.slice(0, 5) ?? '')
</script>

<template>
  <div class="bx-content bx-epg-detail-header">
    <div class="bx-epg-detail-header__airtime-logo bx-typo--content-meta bx-typo--epg">
      <span>{{ startTime }}</span>
      <Channel :channel="additionalHeaders?.metadata?.top?.channel"
               :in-header="true" />
    </div>
    <div class="bx-epg-detail-header__content">
      <MetadataHeader v-if="additionalHeaders?.metadata?.top"
                      :meta-infos="additionalHeaders.metadata.top" />
      <VodEpgBadges v-if="additionalHeaders?.badges"
                    :badges="additionalHeaders.badges" />
      <Roofline v-if="roofline && roofline.length > 0"
                :text="roofline" />
      <Headline v-if="headline && headline.length > 0"
                :seeding="seeding"
                :text="headline" />
      <MetadataHeader v-if="additionalHeaders?.metadata?.bottom"
                      :meta-infos="additionalHeaders.metadata.bottom" />
    </div>
  </div>
</template>
